import React, { useRef, useEffect, useCallback } from "react";
import "./ChatInput.css";
import { ASSISTANT_STRINGS } from "../assistantConstants";

const StopSquare = () => (
  <svg className="chat-stop-icon" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="16" height="16" rx="3" />
  </svg>
);

export default function ChatInput({
  value,
  onChange,
  onSend,
  onStop,
  isProcessing,
}) {
  const textareaRef = useRef(null);
  const hasValue = Boolean(value.trim());

  const autoResize = useCallback(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, 120)}px`;
  }, []);

  useEffect(() => {
    autoResize();
  }, [value, autoResize]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!isProcessing && hasValue) {
        onSend();
      }
    }
  };

  return (
    <div className="chat-input-container">
      <div className="chat-input-box">
        <textarea
          ref={textareaRef}
          className="chat-input-textarea"
          value={value}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          placeholder="Ask Video Insights Assistant..."
          aria-label="Ask Video Insights Assistant"
          id="chat-input"
          rows={1}
        />
        {isProcessing ? (
          <button className="chat-stop-btn" onClick={onStop} aria-label="Stop">
            <StopSquare />
          </button>
        ) : (
          <button
            className={`chat-send-btn ${hasValue ? "chat-send-btn--active" : "chat-send-btn--inactive"}`}
            onClick={onSend}
            disabled={!hasValue}
            aria-label="Send"
          >
            Send
          </button>
        )}
      </div>
      <p className="chat-disclaimer">
        {ASSISTANT_STRINGS.DISCLAIMER}
      </p>
    </div>
  );
}
